export default {
    resellerCreate: {
        method: 'PUT',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/create'
    },
    resellersIndex: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/resellers',
    },
    resellerView: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/:id'
    },
    getModulesByResellerId: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/modules/:id'
    },
    resellerUpdate: {
        method: 'PUT',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/reseller/:id'
    }
}